(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* ---------- Close button ---------- */
  var bars = document.querySelectorAll('.ann-bar[data-section-id]');
  bars.forEach(function(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    var key = 'ann-closed-' + sectionId;
    var closeBtn = bar.querySelector('.ann-bar__close');
    var parentSection = bar.parentElement;

    if (localStorage.getItem(key)) {
      if (parentSection) parentSection.style.display = 'none';
      return;
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        localStorage.setItem(key, '1');
        if (parentSection) parentSection.style.display = 'none';
      });
    }
  });

  /* ---------- Countdown timers ---------- */
  function updateCountdown(el) {
    var targetDate = new Date(el.getAttribute('data-date'));
    var afterText = el.getAttribute('data-after') || '';
    var showSeconds = el.getAttribute('data-seconds') === 'true';

    var now = new Date();
    var diff = targetDate - now;

    if (isNaN(diff) || diff <= 0) {
      el.textContent = afterText;
      return false;
    }

    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins = Math.floor((diff % 3600000) / 60000);
    var secs = Math.floor((diff % 60000) / 1000);

    var parts = [];
    if (days > 0) parts.push(days + 'd');
    if (hours > 0 || days > 0) parts.push(hours + 'h');
    parts.push(mins + 'm');
    if (showSeconds || parts.length === 1) parts.push(secs + 's');

    el.textContent = parts.join(' ');
    return true;
  }

  var countdowns = document.querySelectorAll('.ann-countdown[data-date]');
  countdowns.forEach(function(el) {
    if (!el.getAttribute('data-date')) return;
    if (updateCountdown(el)) {
      setInterval(function() { updateCountdown(el); }, 1000);
    }
  });

  /* ---------- Fade rotator (centred + arrows) ---------- */
  document.querySelectorAll('[data-ann-rotate]').forEach(function (root) {
    var items = root.querySelectorAll('.ann-bar__fade-item');
    if (items.length < 2) return;
    var i = 0, timer = null;
    var step = parseInt(root.getAttribute('data-rotate-ms'), 10) || 4500;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var wrap = root.parentElement;
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (it, idx) { it.classList.toggle('is-active', idx === i); });
    }
    function start() { stop(); if (autoplay) { timer = setInterval(function () { show(i + 1); }, step); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var prev = wrap && wrap.querySelector('[data-ann-prev]');
    var next = wrap && wrap.querySelector('[data-ann-next]');
    prev && prev.addEventListener('click', function () { show(i - 1); start(); });
    next && next.addEventListener('click', function () { show(i + 1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["art-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-art-quiz]');
  if (!root) return;

  // ── Config ────────────────────────────────────────────────────────
  var SOURCE       = root.getAttribute('data-source-collection') || 'all';
  var ROUNDS       = parseInt(root.getAttribute('data-rounds') || '5', 10);
  var PER_ROUND_D  = parseInt(root.getAttribute('data-cards-per-round') || '6', 10);
  var PER_ROUND_M  = parseInt(root.getAttribute('data-cards-mobile') || '4', 10);
  var RESULTS_N    = parseInt(root.getAttribute('data-results-count') || '4', 10);
  var KLAVIYO_ID   = root.getAttribute('data-klaviyo-id') || '';
  var KLAVIYO_LIST = root.getAttribute('data-klaviyo-list') || '';

  // Theme-editor overrides (round headlines + per-category reveal text) passed as JSON.
  var CFG = {};
  try {
    var cfgEl = root.querySelector('[data-quiz-config]');
    if (cfgEl) CFG = JSON.parse(cfgEl.textContent);
  } catch (e) { CFG = {}; }

  // Desktop shows PER_ROUND_D cards (2x3), mobile shows PER_ROUND_M (2x2).
  function perRound() {
    return (window.matchMedia && window.matchMedia('(min-width: 720px)').matches)
      ? PER_ROUND_D : PER_ROUND_M;
  }

  // Four categories, in order. Each has a slug (matches the product tag,
  // lowercased), a display name, and a "you are" read written in Bahar's voice
  // (no em dashes). DRAFT COPY pending Ali/Bahar review before launch.
  var CATEGORIES = {
    'metamorphosis': {
      name: 'The Becoming',
      body: "You don't think of yourself as one fixed thing. You've changed shape before and you'll do it again, and each time it wasn't a loss, it was arrival. The art you picked doesn't hold still either. Neither do you, and you've stopped apologizing for it.",
      notes: [
        "For every version of you that had to leave the last one behind.",
        "For the reinvention nobody warned you was coming.",
        "For the shape you're still growing into.",
        "For when becoming feels more true than arriving.",
        "For the self you're building on purpose."
      ]
    },
    'solitude': {
      name: 'The Quiet Observer',
      body: "You notice things other people walk past. Not in a dramatic way. You're just always a little tuned in, and you've learned to keep most of it to yourself because not everyone wants to know. The art you picked is quiet for the same reason you are.",
      notes: [
        "For the mornings you don't want to talk yet.",
        "For the part of you that finds the window before the people.",
        "For when the room is loud and you stop trying to fix it.",
        "For the small hours that belong only to you.",
        "For the version of yourself that listens first."
      ]
    },
    'creatures': {
      name: 'The Wild Kin',
      body: "You don't split the world into people and everything else. Some of what moves you doesn't walk on two legs, and you're fine with that. It doesn't have to explain itself and neither do you. The art you picked isn't tame, and you didn't pick it to be understood. You picked it because you recognized it.",
      notes: [
        "For the part of you that talks to animals like they'll answer.",
        "For the creature that lives in you and asks for nothing.",
        "For when the wild thing makes more sense than the tame one.",
        "For the kinship that doesn't need a shared language.",
        "For the part of you that was never fully tamed."
      ]
    },
    'together-apart': {
      name: 'The In-Between',
      body: "You've never found a relationship that stays still. People come close and then they drift, and you've learned both are true at once, not one replacing the other. The art you picked lives in that same space, between reaching and letting go. You're not confused by it. You just know closeness is never really finished.",
      notes: [
        "For the people who are with you and still far away.",
        "For the closeness that comes and goes without leaving.",
        "For the love that doesn't need to be resolved to be real.",
        "For the space between two people that means something too.",
        "For when apart is just another way of being together."
      ]
    }
  };
  var CATEGORY_ORDER = ['metamorphosis','solitude','creatures','together-apart'];

  // Apply theme-editor overrides for each category's reveal text.
  if (CFG.categoryText) {
    CATEGORY_ORDER.forEach(function(slug){
      var t = CFG.categoryText[slug];
      if (t && String(t).trim() && CATEGORIES[slug]) CATEGORIES[slug].body = String(t);
    });
  }

  var DEFAULT_PROMPTS = [
    'Which one pulls you in?',
    'And now?',
    'Which one stays with you?',
    'Last one. Trust your eye.',
    'One more. Go with your gut.'
  ];
  // Editor-set headline per round, falling back to the defaults above.
  function roundHeading(idx) {
    var custom = (CFG.roundHeadings && CFG.roundHeadings[idx]) ? String(CFG.roundHeadings[idx]).trim() : '';
    if (custom) return custom;
    return DEFAULT_PROMPTS[idx] || DEFAULT_PROMPTS[DEFAULT_PROMPTS.length - 1];
  }

  // ── DOM ──────────────────────────────────────────────────────────
  var steps         = root.querySelectorAll('[data-step]');
  var introStep     = root.querySelector('[data-step="intro"]');
  var roundStep     = root.querySelector('[data-step="round"]');
  var revealStep    = root.querySelector('[data-step="reveal"]');
  var beginBtn      = root.querySelector('[data-begin]');
  var progressWrap  = root.querySelector('[data-progress-wrap]');
  var progressBar   = root.querySelector('[data-progress-bar]');
  var roundEyebrow  = root.querySelector('[data-round-eyebrow]');
  var roundPrompt   = root.querySelector('[data-round-prompt]');
  var picksGrid     = root.querySelector('[data-picks-grid]');
  var categoryName  = root.querySelector('[data-category-name]');
  var categoryBody  = root.querySelector('[data-category-body]');
  var resultsGrid   = root.querySelector('[data-results-grid]');
  var exploreLink   = root.querySelector('[data-explore-link]');
  var restartBtns   = root.querySelectorAll('[data-restart]');
  var emailForm     = root.querySelector('[data-email-form]');
  var emailBlock    = root.querySelector('[data-email-block]');
  var formError     = root.querySelector('[data-form-error]');
  var submitLabel   = root.querySelector('[data-submit-label]');
  var submitLoad    = root.querySelector('[data-submit-loading]');
  var submitBtn     = emailForm ? emailForm.querySelector('button[type="submit"]') : null;
  var emailSuccess  = root.querySelector('[data-email-success]');

  // ── State ────────────────────────────────────────────────────────
  var allProducts = [];       // raw products, post-filter quiz-eligible
  var poolByCategory = {};    // { categorySlug: [products] }
  var currentRound = 0;
  var roundPicks = [];        // [{ categories, product }] one per round
  var scores = {};            // { categorySlug: number }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[<>"'&]/g, function(c) {
      return { '<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;','&':'&amp;' }[c];
    });
  }
  function normalizeTags(tags) {
    return (Array.isArray(tags) ? tags : []).map(function(t){ return String(t).trim().toLowerCase(); });
  }
  function productCategories(prodTags) {
    var found = [];
    for (var i = 0; i < CATEGORY_ORDER.length; i++) {
      if (prodTags.indexOf(CATEGORY_ORDER[i]) !== -1) found.push(CATEGORY_ORDER[i]);
    }
    return found;
  }
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  // ── Load products ────────────────────────────────────────────────
  function loadProducts(cb) {
    fetch('/collections/' + SOURCE + '/products.json?limit=250')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var prods = (data.products || []);
        allProducts = prods.filter(function(p){
          var tags = normalizeTags(p.tags);
          if (tags.indexOf('quiz-eligible') === -1) return false;
          if (tags.indexOf('sold') !== -1) return false;
          return true;
        }).map(function(p){
          var tags = normalizeTags(p.tags);
          // Only use Gelato frame mockups: those are the variant-linked images
          // (each frame colour/size has one). Lifestyle, zoom and flat-scan shots
          // are not attached to any variant, so we exclude them. Random pick across
          // the mockups naturally varies the frame colour.
          var img = '';
          var imgs = p.images || [];
          var frameImgs = imgs.filter(function(im){ return im.variant_ids && im.variant_ids.length; });
          var pool = frameImgs.length ? frameImgs : imgs;
          if (pool.length) {
            var chosen = pool[Math.floor(Math.random() * pool.length)];
            img = chosen.src.replace(/\?.*$/, '');
          }
          return {
            handle: p.handle,
            title:  p.title,
            image:  img,
            tags:   tags,
            categories: productCategories(tags)
          };
        }).filter(function(p){ return p.categories.length && p.image; });

        // Group by category (each product carries exactly one category)
        poolByCategory = {};
        CATEGORY_ORDER.forEach(function(c){ poolByCategory[c] = []; });
        allProducts.forEach(function(p){
          p.categories.forEach(function(c){
            if (poolByCategory[c]) poolByCategory[c].push(p);
          });
        });
        cb();
      })
      .catch(function(){ cb(); });
  }

  // ── Round pool selection ─────────────────────────────────────────
  // For each round, round-robin through the 4 categories (starting offset
  // shifts one category per round) and pull one random unused product per
  // slot. With only 4 categories and PER_ROUND typically 6, categories repeat
  // within a round by design — the offset keeps which categories get the
  // "extra" slots varying round to round.
  var usedHandles = {};
  function buildRound(roundIdx) {
    var PER_ROUND = perRound();
    var offset = roundIdx % CATEGORY_ORDER.length;
    var picks = [];
    var i = 0;
    var guard = 0;
    var maxGuard = PER_ROUND * CATEGORY_ORDER.length * 4;
    while (picks.length < PER_ROUND && guard < maxGuard) {
      var cat = CATEGORY_ORDER[(offset + i) % CATEGORY_ORDER.length];
      var bucket = (poolByCategory[cat] || []).filter(function(p){ return !usedHandles[p.handle]; });
      if (bucket.length) {
        var pick = bucket[Math.floor(Math.random() * bucket.length)];
        picks.push(pick);
        usedHandles[pick.handle] = true;
      }
      i++;
      guard++;
    }
    // If still short (categories exhausted globally), backfill from any unused product
    if (picks.length < PER_ROUND) {
      var pool = allProducts.filter(function(p){ return !usedHandles[p.handle]; });
      pool = shuffle(pool);
      while (picks.length < PER_ROUND && pool.length) {
        var p = pool.shift();
        picks.push(p);
        usedHandles[p.handle] = true;
      }
    }
    return shuffle(picks);
  }

  // ── Rendering ─────────────────────────────────────────────────────
  function showStep(name) {
    Array.prototype.forEach.call(steps, function(s){
      var match = s.getAttribute('data-step') === name;
      if (match) { s.removeAttribute('hidden'); s.classList.add('art-quiz__step--active'); }
      else       { s.setAttribute('hidden', ''); s.classList.remove('art-quiz__step--active'); }
    });
    if (progressWrap) {
      if (name === 'round') progressWrap.removeAttribute('hidden');
      else                  progressWrap.setAttribute('hidden', '');
    }
  }

  function renderRound() {
    var picks = buildRound(currentRound);
    if (!picks.length) { goToReveal(); return; }
    roundEyebrow.textContent = 'Round ' + (currentRound + 1) + ' of ' + ROUNDS;
    roundPrompt.textContent  = roundHeading(currentRound);
    picksGrid.innerHTML = picks.map(function(p){
      return '<button type="button" class="art-quiz__pick" data-handle="' + escapeHtml(p.handle) +
        '" data-categories="' + escapeHtml(p.categories.join(',')) + '">' +
        '<span class="art-quiz__pick-img-wrap">' +
          '<img class="art-quiz__pick-img" src="' + p.image + '?width=600" alt="" loading="lazy">' +
        '</span>' +
      '</button>';
    }).join('');
    progressBar.style.width = Math.round((currentRound / ROUNDS) * 100) + '%';
  }

  function handlePick(btn) {
    var categoriesAttr = btn.getAttribute('data-categories') || '';
    var pickCategories = categoriesAttr ? categoriesAttr.split(',').filter(Boolean) : [];
    var handle    = btn.getAttribute('data-handle');
    var picked = allProducts.find(function(p){ return p.handle === handle; });
    if (!pickCategories.length || !picked) return;
    // Score: the category on the picked product gets +1, last round 2x weight.
    var weight = (currentRound === ROUNDS - 1) ? 2 : 1;
    pickCategories.forEach(function(c){
      scores[c] = (scores[c] || 0) + (1 * weight);
    });
    roundPicks.push({ categories: pickCategories, product: picked });
    currentRound++;
    if (currentRound >= ROUNDS) goToReveal();
    else renderRound();
  }

  picksGrid.addEventListener('click', function(e){
    var btn = e.target.closest('.art-quiz__pick');
    if (btn) handlePick(btn);
  });

  // ── Reveal & curated recommendations ─────────────────────────────
  function pickWinner() {
    var ranked = CATEGORY_ORDER
      .map(function(c){ return { c: c, s: scores[c] || 0 }; })
      .sort(function(x, y){ return y.s - x.s; });
    if (!ranked[0].s) return CATEGORY_ORDER[0];
    return ranked[0].c;
  }
  function pickRunnerUp(winner) {
    var ranked = CATEGORY_ORDER
      .filter(function(c){ return c !== winner; })
      .map(function(c){ return { c: c, s: scores[c] || 0 }; })
      .sort(function(x, y){ return y.s - x.s; });
    return ranked.length ? ranked[0].c : winner;
  }
  function curatedResults(winner, runnerUp) {
    var primaryPool   = (poolByCategory[winner] || []).slice();
    var secondaryPool = (poolByCategory[runnerUp] || []).slice();
    // Bridge = winner-category products that also carry the runner-up category.
    // Categories are mutually exclusive per product now, so this is always
    // empty and falls back to primaryPool below — kept for structural parity.
    var bridgePool    = primaryPool.filter(function(p){ return p.categories.indexOf(runnerUp) !== -1; });
    // Stretch = runner-up-category products that do NOT also carry the winner category
    var stretchPool   = secondaryPool.filter(function(p){ return p.categories.indexOf(winner) === -1; });

    var pickedHandles = {};
    roundPicks.forEach(function(rp){ pickedHandles[rp.product.handle] = true; });
    function takeUnused(pool) {
      var shuffled = shuffle(pool);
      for (var i = 0; i < shuffled.length; i++) {
        if (!pickedHandles[shuffled[i].handle]) {
          pickedHandles[shuffled[i].handle] = true;
          return shuffled[i];
        }
      }
      return null;
    }
    var results = [];
    var a = takeUnused(primaryPool); if (a) results.push(a);
    var b = takeUnused(bridgePool.length ? bridgePool : primaryPool); if (b) results.push(b);
    var c = takeUnused(primaryPool); if (c) results.push(c);
    var d = takeUnused(primaryPool); if (d) results.push(d);
    var e = takeUnused(stretchPool.length ? stretchPool : secondaryPool); if (e) results.push(e);
    // Backfill if any slot empty
    while (results.length < RESULTS_N) {
      var fb = takeUnused(allProducts);
      if (!fb) break;
      results.push(fb);
    }
    return results.slice(0, RESULTS_N);
  }

  function goToReveal() {
    progressBar.style.width = '100%';
    showStep('reveal');
    var winner = pickWinner();
    var runnerUp = pickRunnerUp(winner);
    var category = CATEGORIES[winner] || CATEGORIES[CATEGORY_ORDER[0]];
    categoryName.textContent = category.name;
    categoryBody.textContent = category.body;
    if (exploreLink) exploreLink.setAttribute('href', '/collections/all/' + winner);

    var picks = curatedResults(winner, runnerUp);
    resultsGrid.innerHTML = picks.map(function(p){
      return '<a class="art-quiz__result-card" href="/products/' + escapeHtml(p.handle) + '">' +
        '<img class="art-quiz__result-img" src="' + p.image + '?width=500" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
        '<p class="art-quiz__result-title">' + escapeHtml(p.title) + '</p>' +
      '</a>';
    }).join('');

    // Stash on root for Klaviyo submission
    root.__quizState = { winner: winner, runnerUp: runnerUp, picks: roundPicks, scores: scores };
  }

  // ── Begin / restart ──────────────────────────────────────────────
  if (beginBtn) beginBtn.addEventListener('click', function(){
    loadProducts(function(){
      if (!allProducts.length) {
        picksGrid.innerHTML = '<p class="art-quiz__loading">No quiz-eligible artworks found. Visit the full collection.</p>';
        showStep('round');
        return;
      }
      currentRound = 0;
      roundPicks = [];
      scores = {};
      usedHandles = {};
      showStep('round');
      renderRound();
    });
  });

  Array.prototype.forEach.call(restartBtns, function(btn){
    btn.addEventListener('click', function(){
      currentRound = 0;
      roundPicks = [];
      scores = {};
      usedHandles = {};
      progressBar.style.width = '0%';
      if (emailSuccess) emailSuccess.hidden = true;
      if (emailForm) {
        emailForm.style.display = '';
        emailForm.reset();
      }
      // Always return to the intro (the true start) and bring the quiz back into
      // view — the reveal step is long, so without scrolling the viewport stays
      // parked at the bottom and the reset looks like nothing happened.
      showStep('intro');
      if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ── Klaviyo subscribe ────────────────────────────────────────────
  if (emailForm) {
    emailForm.addEventListener('submit', function(e){
      e.preventDefault();
      var emailInput = emailForm.querySelector('[name="email"]');
      var firstNameInput = emailForm.querySelector('[name="firstName"]');
      var email = emailInput ? emailInput.value.trim() : '';
      var firstName = firstNameInput ? firstNameInput.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (formError) { formError.textContent = 'Please enter a valid email.'; formError.hidden = false; }
        return;
      }
      if (formError) formError.hidden = true;
      if (submitLabel) submitLabel.hidden = true;
      if (submitLoad)  submitLoad.hidden  = false;
      if (submitBtn)   submitBtn.disabled = true;

      var state = root.__quizState || {};
      var quizProps = {
        quiz_completed:    true,
        quiz_version:      '4-category',
        quiz_completed_at: new Date().toISOString(),
        quiz_category:            state.winner || '',
        quiz_category_secondary:  state.runnerUp || '',
        quiz_picks:        (state.picks || []).map(function(p){ return p.product.handle; }),
        quiz_scores:       state.scores || {}
      };
      var profileAttrs = { email: email, properties: quizProps };
      if (firstName) profileAttrs.first_name = firstName;
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Art Quiz (category)',
            profile: { data: { type: 'profile', attributes: profileAttrs } }
          }
        }
      };
      if (KLAVIYO_LIST) body.data.relationships = { list: { data: { type: 'list', id: KLAVIYO_LIST } } };

      function finish() {
        if (emailForm) emailForm.style.display = 'none';
        if (emailSuccess) emailSuccess.hidden = false;
        if (submitBtn) submitBtn.disabled = false;
        if (submitLabel) submitLabel.hidden = false;
        if (submitLoad)  submitLoad.hidden  = true;
      }

      if (!KLAVIYO_ID) { finish(); return; }
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_ID), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
        body: JSON.stringify(body)
      }).then(finish, finish);
    });
  }

  // ── Init ─────────────────────────────────────────────────────────
  // Quiz starts on the intro step (already active via initial markup).
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ed-hero]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-ed-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-ed-dot]');
    var i = 0, timer = null;
    var autoplay = root.dataset.autoplay !== 'false';
    var speed = (parseFloat(root.dataset.speed) || 7) * 1000;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    function next() { show(i + 1); }
    function prev() { show(i - 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(next, speed); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var nextBtn = root.querySelector('[data-ed-next]');
    var prevBtn = root.querySelector('[data-ed-prev]');
    nextBtn && nextBtn.addEventListener('click', function () { next(); start(); });
    prevBtn && prevBtn.addEventListener('click', function () { prev(); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.edDot, 10)); start(); });
    });

    // Touch swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      x0 = null; start();
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });

  // Scroll-down circle: jump to the next visible section after the hero.
  // Skips zero-height sections (e.g. an empty Recently Viewed on a first visit).
  document.querySelectorAll('[data-ed-scroll]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var next = btn.closest('.shopify-section');
      next = next ? next.nextElementSibling : null;
      while (next && next.offsetHeight === 0) { next = next.nextElementSibling; }
      if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-featured-tabs]').forEach(function(root) {
    var tabs = root.querySelectorAll('.featured-tabs__tab');
    var panels = root.querySelectorAll('.featured-tabs__panel');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var id = tab.dataset.tab;
        tabs.forEach(function(t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function(p) {
          var on = p.dataset.panel === id;
          p.classList.toggle('is-active', on);
          if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  var carousels = document.querySelectorAll('[data-fw-carousel]');
  carousels.forEach(function (carousel) {
    var track = carousel.querySelector('[data-fw-track]');
    var prev = carousel.querySelector('[data-fw-prev]');
    var next = carousel.querySelector('[data-fw-next]');
    if (!track) return;

    function pageWidth() {
      var item = track.querySelector('.featured-works__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var cardW = item.getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.round(track.clientWidth / cardW));
      return perView * cardW;
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.hidden = track.scrollLeft <= 1;
      if (next) next.hidden = track.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -pageWidth(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: pageWidth(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-wall-builder"] && !Shopify.designMode) return;
  try {
    
(function() {
  var root = document.querySelector('[data-gwb-section]');
  if (!root) return;
  var builder = root.querySelector('.gwb__builder');
  if (!builder) return;

  var exitBtn = root.querySelector('[data-gwb-exit]');
  if (exitBtn) {
    exitBtn.addEventListener('click', function(e) {
      var ref = document.referrer;
      var sameOrigin = ref && ref.indexOf(window.location.origin) === 0;
      if (sameOrigin && ref !== window.location.href && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
    });
  }

  var canvas = root.querySelector('[data-gwb-canvas]');
  var productsEl = root.querySelector('[data-gwb-products]');
  var addAllBtn = root.querySelector('[data-gwb-add-all]');
  var emptyEl = root.querySelector('[data-gwb-empty]');
  var searchInput = root.querySelector('[data-gwb-search]');
  // scaleSlider removed, sizes drive visualization, no scale slider needed.
  var subtotalWrap = root.querySelector('[data-gwb-subtotal-wrap]');
  var subtotalEl = root.querySelector('[data-gwb-subtotal]');
  var subtotalCompare = root.querySelector('[data-gwb-subtotal-compare]');
  var uploadInput = root.querySelector('[data-gwb-upload]');
  var mockupRow = root.querySelector('[data-gwb-mockup-row]');

  // Mobile-only nodes (rendered always; hidden on desktop via CSS)
  var sidebarEl = root.querySelector('[data-gwb-sidebar]');
  var openPickerBtn = root.querySelector('[data-gwb-open-picker]');
  var sheetOverlay = root.querySelector('[data-gwb-sheet-overlay]');
  var sheetCloseBtn = root.querySelector('[data-gwb-sheet-close]');
  var actionBar = root.querySelector('[data-gwb-action-bar]');
  var mobileSubtotalWrap = root.querySelector('[data-gwb-mobile-subtotal-wrap]');
  var mobileSubtotal = root.querySelector('[data-gwb-mobile-subtotal]');
  var mobileSubtotalCompare = root.querySelector('[data-gwb-mobile-subtotal-compare]');
  var mobileSubtotalEmpty = root.querySelector('[data-gwb-mobile-subtotal-empty]');
  var mobileAddBtn = root.querySelector('[data-gwb-mobile-add]');
  var mobileSizeSelect = root.querySelector('[data-gwb-mobile-size]');
  var mobileFrameSelect = root.querySelector('[data-gwb-mobile-frame]');
  var mobileFrameRow = root.querySelector('[data-gwb-frame-row]');
  var mobileDeleteBtn = root.querySelector('[data-gwb-mobile-delete]');

  var mobileMq = window.matchMedia('(max-width: 768px)');
  function isMobile() { return mobileMq.matches; }

  var collectionHandle = builder.getAttribute('data-gwb-collection') || 'all';
  var moneyFmt = builder.getAttribute('data-money-format') || ('$' + '{' + '{amount}}');
  // Two-strategy scaling: separate `scene_cm` for desktop vs mobile.
  //
  // Why two values: a phone canvas is narrower than a desktop canvas (~360 px
  // vs ~700 px), so the same `scene_cm` would render artwork at the same
  // FRACTION of the canvas on both, and a 12 %-of-canvas piece feels right
  // on desktop (lots of breathing room) but cramped on mobile (artwork hard
  // to see / drag). Inverting it: we want a slightly higher canvas-fraction
  // on mobile to keep prints interactive, lower on desktop to leave context.
  //
  // The formula is:  cmPerPx = canvas.clientWidth / sceneCm
  // …where sceneCm is picked per device. `cmPerPx()` re-reads `isMobile()`
  // every call so a browser-resize that crosses the breakpoint flips strategy.
  // ResizeObserver below re-renders all placed frames on canvas resize.
  //
  // Tuning levers (section settings; defaults shown):
  //   desktop: 240  → 30 cm print ≈ 12 % canvas width (any desktop canvas)
  //   mobile:  200  → 30 cm print ≈ 15 % canvas width (any phone canvas)
  // Lower = larger artwork. Raise the value if a device-class feels too big.
  var DESKTOP_SCENE_CM = parseFloat(builder.getAttribute('data-scene-cm-desktop') || '240');
  var MOBILE_SCENE_CM  = parseFloat(builder.getAttribute('data-scene-cm-mobile')  || '200');
  function cmPerPx() {
    var w = canvas.clientWidth || canvas.getBoundingClientRect().width || 800;
    return w / (isMobile() ? MOBILE_SCENE_CM : DESKTOP_SCENE_CM);
  }

  var products = [];
  var items = [];
  var selectedId = null;
  var idCounter = 0;

  // ---------- helpers ----------

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var O = '{' + '{', C = '}' + '}';
    return moneyFmt
      .replace(O + 'amount' + C, amount)
      .replace(O + 'amount_no_decimals' + C, String(Math.round(cents / 100)))
      .replace(O + 'amount_with_comma_separator' + C, amount.replace('.', ','))
      .replace(O + 'amount_no_decimals_with_comma_separator' + C, String(Math.round(cents / 100)));
  }

  function inchLabel(sizeStr) {
    // Variant titles look like "30x40 cm / 12x16″". Pull the inches portion
    // (after the slash) for display, Bahar's primary market is US/CA where
    // inches are intuitive. Fall back to the raw string if the title isn't
    // in the expected dual-unit format.
    var parts = (sizeStr || '').split('/');
    if (parts.length < 2) return sizeStr;
    return parts[parts.length - 1].trim();
  }

  function parseSize(sizeStr, orientation) {
    // "30x40 cm / 12x16″" → {w: 30, h: 40, ratio: 0.75}
    // Variant titles always list portrait dimensions (smaller × larger), and some
    // sizes use decimals (e.g. "21x29.7 cm" for A4). Regex allows decimals so the
    // default fallback never kicks in for real Bahar variants.
    // For horizontal artworks, swap so the placed frame is landscape.
    var m = sizeStr.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*cm/i);
    var a, b;
    if (m) { a = parseFloat(m[1]); b = parseFloat(m[2]); }
    else   { a = 30; b = 40; }
    var w, h;
    if (orientation === 'horizontal') { w = b; h = a; }
    else                              { w = a; h = b; }
    return { w: w, h: h, ratio: w / h };
  }

  function getOrientationFromProduct(p) {
    var tagsArr = Array.isArray(p.tags) ? p.tags
      : (typeof p.tags === 'string' ? p.tags.split(',').map(function(t){return t.trim();}) : []);
    for (var i = 0; i < tagsArr.length; i++) {
      if ((tagsArr[i] || '').toLowerCase() === 'horizontal') return 'horizontal';
    }
    return 'vertical';
  }

  function priceCents(priceStr) {
    // Shopify products.json returns price as decimal string ("219.00")
    return Math.round(parseFloat(priceStr) * 100);
  }

  // ---------- product loading ----------

  function buildVariantIndex(product) {
    var idx = {};
    var sizes = [], frames = [];
    var sizeSet = {}, frameSet = {};
    (product.variants || []).forEach(function(v) {
      var size = '', frame = '';
      (v.options || []).forEach(function(opt, i) {
        var name = (product.options && product.options[i]) ? product.options[i] : '';
        if (/size/i.test(name)) size = opt;
        else if (/frame/i.test(name)) frame = opt;
      });
      // Fallback: parse from variant title "27x35 cm / 11x14″ / Wood frame"
      if (!size || !frame) {
        var parts = (v.title || '').split(' / ');
        if (parts.length >= 3) { size = size || parts[0] + ' / ' + parts[1]; frame = frame || parts[2]; }
      }
      var key = size + '|' + frame;
      idx[key] = {
        id: v.id,
        price: priceCents(v.price),
        compareAtPrice: v.compare_at_price ? priceCents(v.compare_at_price) : null,
        imageUrl: (v.featured_image && v.featured_image.src) ? v.featured_image.src.replace(/\?.*$/, '') : (product.images[0] && product.images[0].src.replace(/\?.*$/, ''))
      };
      if (!sizeSet[size]) { sizeSet[size] = 1; sizes.push(size); }
      if (!frameSet[frame]) { frameSet[frame] = 1; frames.push(frame); }
    });
    return { idx: idx, sizes: sizes, frames: frames };
  }

  function renderProductCard(p) {
    var card = document.createElement('div');
    card.className = 'gwb__product-card';
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.dataset.title = (p.title || '').toLowerCase();
    var v0 = (p.variants && p.variants[0]) || {};
    var img0 = (v0.featured_image && v0.featured_image.src) || (p.images[0] && p.images[0].src) || '';
    img0 = img0.replace(/\?.*$/, '');
    var startingPrice = priceCents(v0.price || '0');

    // tags from products.json: array of strings (lowercase set for matching)
    var tagsArr = Array.isArray(p.tags) ? p.tags : (typeof p.tags === 'string' ? p.tags.split(',').map(function(t){return t.trim();}) : []);
    var tagsLower = tagsArr.map(function(t){return t.toLowerCase();});
    card.dataset.tags = '|' + tagsLower.join('|') + '|';

    // Product type for Prints / Originals tabs: `Print` tag (case-insensitive) is the marker.
    card.dataset.productType = tagsLower.indexOf('print') !== -1 ? 'print' : 'original';

    // Orientation comes from the `horizontal` product tag (synced from Shopify Orientation metafield).
    // Default = vertical when the tag is absent (all artwork is portrait/square by default).
    card.dataset.orientation = getOrientationFromProduct(p);

    card.innerHTML =
      '<div class="gwb__product-img-wrap">' +
        (img0 ? '<img class="gwb__product-img" src="' + img0 + '?width=320" alt="' + (p.title || '').replace(/"/g, '') + '" loading="lazy">' : '') +
        '<button type="button" class="gwb__product-quickadd" tabindex="-1">Add</button>' +
      '</div>' +
      '<div class="gwb__product-info">' +
        '<p class="gwb__product-name">' + (p.title || '') + '</p>' +
        '<p class="gwb__product-price">From ' + formatMoney(startingPrice) + '</p>' +
      '</div>';

    var addProduct = function() { addFrameForProduct(p); };
    card.addEventListener('click', addProduct);
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); addProduct(); }
    });
    return card;
  }

  function loadProducts() {
    // limit=250 is Shopify's max for products.json. Earlier 50 caused the search
    // to miss anything past the 50th product in catalog order (e.g. Pregnancy,
    // Pride, etc.), Ali reported the search "not working" for those names.
    fetch('/collections/' + collectionHandle + '/products.json?limit=250')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        productsEl.innerHTML = '';
        products = (data.products || []).filter(function(p) { return p.variants && p.variants.length; });
        if (!products.length) {
          productsEl.innerHTML = '<p class="gwb__loading">No prints found.</p>';
          return;
        }
        products.forEach(function(p) {
          p.__index = buildVariantIndex(p);
          productsEl.appendChild(renderProductCard(p));
        });
        runFilters();
        deepLinkPlace();
      })
      .catch(function() {
        productsEl.innerHTML = '<p class="gwb__loading">Could not load works.</p>';
        deepLinkPlace();
      });
  }

  // ---------- deep-link: ?product=<handle> auto-places that product on boot ----------
  function deepLinkPlace() {
    var handle = null;
    try { handle = new URLSearchParams(window.location.search).get('product'); } catch (e) {}
    if (!handle) return;
    // First try to find it in the already-loaded collection (instant, no extra fetch)
    for (var i = 0; i < products.length; i++) {
      if (products[i].handle === handle) {
        addFrameForProduct(products[i]);
        return;
      }
    }
    // Fallback for products outside the configured collection (e.g. originals when builder is wired to 'prints').
    // /products/<handle>.js has a different shape than /products.json, normalize on the fly.
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p || !p.variants || !p.variants.length) return;
        // .js endpoint: price = integer cents, compare_at_price = integer cents or null,
        // featured_image = string URL, images = array of strings.
        p.variants = p.variants.map(function(v) {
          var out = {}; for (var k in v) out[k] = v[k];
          if (typeof v.price === 'number') out.price = (v.price / 100).toFixed(2);
          if (typeof v.compare_at_price === 'number' && v.compare_at_price) {
            out.compare_at_price = (v.compare_at_price / 100).toFixed(2);
          }
          if (typeof v.featured_image === 'string') out.featured_image = { src: v.featured_image };
          return out;
        });
        if (p.images && p.images.length && typeof p.images[0] === 'string') {
          p.images = p.images.map(function(src) { return { src: src }; });
        }
        p.__index = buildVariantIndex(p);
        addFrameForProduct(p);
      })
      .catch(function() {});
  }

  // ---------- placing frames ----------

  function addFrameForProduct(product) {
    var idx = product.__index;
    // Default to the middle size + wood frame (or first available)
    var defaultSize = idx.sizes[Math.min(1, idx.sizes.length - 1)];
    var defaultFrame = idx.frames.indexOf('Wood frame') >= 0 ? 'Wood frame' : idx.frames[0];
    var variant = idx.idx[defaultSize + '|' + defaultFrame] || idx.idx[Object.keys(idx.idx)[0]];
    var orientation = getOrientationFromProduct(product);

    var rect = canvas.getBoundingClientRect();
    var parsed = parseSize(defaultSize, orientation);
    var ppc = cmPerPx();
    var baseW = parsed.w * ppc;
    var baseH = parsed.h * ppc;
    var x = Math.max(8, Math.min(Math.round(rect.width / 2 - baseW / 2 + (Math.random() - 0.5) * 100), rect.width - baseW - 8));
    var y = Math.max(8, Math.min(Math.round(rect.height / 2 - baseH / 2 + (Math.random() - 0.5) * 60), rect.height - baseH - 8));

    var item = {
      id: ++idCounter,
      productId: product.id,
      productHandle: product.handle,
      productTitle: product.title,
      idx: idx,
      orientation: orientation,
      size: defaultSize,
      frame: defaultFrame,
      variantId: variant.id,
      price: variant.price,
      compareAtPrice: variant.compareAtPrice,
      imageUrl: variant.imageUrl,
      x: x, y: y,
      scale: 1
    };
    items.push(item);
    renderFrame(item);
    selectFrame(item.id);
    updateChrome();
  }

  function renderFrame(item) {
    var parsed = parseSize(item.size, item.orientation);
    var ppc = cmPerPx();
    var w = parsed.w * ppc * item.scale;
    var h = parsed.h * ppc * item.scale;
    item._w = w; item._h = h;

    var el = document.createElement('div');
    el.className = 'gwb__frame';
    el.dataset.frameId = item.id;
    el.dataset.frame = item.frame;
    el.style.cssText = 'left:' + item.x + 'px;top:' + item.y + 'px;width:' + w + 'px;height:' + h + 'px;';

    var img = document.createElement('img');
    img.src = item.imageUrl + '?width=600';
    img.alt = item.productTitle || '';
    // Adjust the bounding box to match the mockup's natural aspect on load.
    // Gelato prints are 1:1 square, originals are 4:5 portrait, same code handles both.
    // We preserve the *area* of the cm-derived box (keeping the to-scale feel) but
    // change W/H so the mock fills the box with no clipping and no letterbox.
    img.onload = function() {
      if (!img.naturalWidth || !img.naturalHeight) return;
      item._mockAspect = img.naturalWidth / img.naturalHeight;
      applyBoxDimensions(item, el);
    };
    el.appendChild(img);

    var del = document.createElement('button');
    del.type = 'button';
    del.className = 'gwb__frame-delete';
    del.innerHTML = '&times;';
    del.setAttribute('aria-label', 'Remove ' + (item.productTitle || 'item'));
    del.addEventListener('pointerdown', function(e) { e.stopPropagation(); });
    del.addEventListener('click', function(e) {
      e.stopPropagation();
      items = items.filter(function(it) { return it.id !== item.id; });
      el.remove();
      if (selectedId === item.id) selectedId = null;
      updateChrome();
    });
    el.appendChild(del);

    var controls = document.createElement('div');
    controls.className = 'gwb__frame-controls';
    controls.addEventListener('pointerdown', function(e) { e.stopPropagation(); });

    var frameSelect = document.createElement('select');
    frameSelect.className = 'gwb__variant-select';
    frameSelect.setAttribute('aria-label', 'Frame');
    item.idx.frames.forEach(function(f) {
      var opt = document.createElement('option');
      opt.value = f; opt.textContent = f.replace(/ frame/i, '');
      if (f === item.frame) opt.selected = true;
      frameSelect.appendChild(opt);
    });
    frameSelect.addEventListener('change', function() {
      item.frame = frameSelect.value;
      applyVariant(item, el);
    });

    var sizeSelect = document.createElement('select');
    sizeSelect.className = 'gwb__variant-select';
    sizeSelect.setAttribute('aria-label', 'Size');
    item.idx.sizes.forEach(function(s) {
      var opt = document.createElement('option');
      opt.value = s; opt.textContent = inchLabel(s);
      if (s === item.size) opt.selected = true;
      sizeSelect.appendChild(opt);
    });
    sizeSelect.addEventListener('change', function() {
      item.size = sizeSelect.value;
      applyVariant(item, el);
    });

    controls.appendChild(frameSelect);
    controls.appendChild(sizeSelect);
    el.appendChild(controls);

    makeDraggable(el, item);

    el.addEventListener('pointerdown', function(e) {
      var t = e.target;
      if (t.tagName === 'SELECT' || t.classList.contains('gwb__frame-delete')) return;
      selectFrame(item.id);
    });

    canvas.appendChild(el);
    item._el = el;
  }

  function applyVariant(item, el) {
    var v = item.idx.idx[item.size + '|' + item.frame];
    if (!v) return;
    item.variantId = v.id;
    item.price = v.price;
    item.compareAtPrice = v.compareAtPrice;
    item.imageUrl = v.imageUrl;
    el.dataset.frame = item.frame;
    // Reset cached mock aspect, the new variant may have a different mock aspect.
    // img.onload (set in renderFrame) will reapply it once the new image loads.
    item._mockAspect = null;
    var imgEl = el.querySelector('img');
    if (imgEl) imgEl.src = v.imageUrl + '?width=600';
    // Set size from cm × scale; img.onload will refine to mock aspect once loaded.
    applyBoxDimensions(item, el);
    updateChrome();
  }

  function selectFrame(id) {
    selectedId = id;
    items.forEach(function(it) {
      if (it._el) it._el.classList.toggle('is-selected', it.id === id);
    });
    var it = currentItem();
    syncMobileFrameControls(it);
    // Frame controls row appears when a frame is selected.
    if (mobileFrameRow) mobileFrameRow.hidden = !it;
  }

  function syncMobileFrameControls(item) {
    if (!mobileSizeSelect || !mobileFrameSelect) return;
    mobileSizeSelect.innerHTML = '';
    mobileFrameSelect.innerHTML = '';
    if (!item || !item.idx) return;
    item.idx.sizes.forEach(function(s) {
      var opt = document.createElement('option');
      opt.value = s; opt.textContent = inchLabel(s);
      if (s === item.size) opt.selected = true;
      mobileSizeSelect.appendChild(opt);
    });
    item.idx.frames.forEach(function(f) {
      var opt = document.createElement('option');
      opt.value = f; opt.textContent = f.replace(/ frame/i, '');
      if (f === item.frame) opt.selected = true;
      mobileFrameSelect.appendChild(opt);
    });
  }

  function currentItem() {
    if (!selectedId) return null;
    for (var i = 0; i < items.length; i++) if (items[i].id === selectedId) return items[i];
    return null;
  }

  // Single-pointer drag only. No pinch, sizes drive visual scaling via the
  // variant Size select. User picks a size to resize on the canvas.
  function makeDraggable(el, item) {
    var dragging = false;
    var startX = 0, startY = 0;
    var startLeft = 0, startTop = 0;
    el.addEventListener('pointerdown', function(e) {
      var t = e.target;
      if (t.classList.contains('gwb__frame-delete') || t.tagName === 'SELECT') return;
      dragging = true;
      startX = e.clientX; startY = e.clientY;
      startLeft = item.x; startTop = item.y;
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });
    el.addEventListener('pointermove', function(e) {
      if (!dragging) return;
      var rect = canvas.getBoundingClientRect();
      item.x = Math.max(0, Math.min(startLeft + (e.clientX - startX), rect.width - (item._w || 100)));
      item.y = Math.max(0, Math.min(startTop + (e.clientY - startY), rect.height - (item._h || 100)));
      el.style.left = item.x + 'px';
      el.style.top = item.y + 'px';
    });
    el.addEventListener('pointerup', function() { dragging = false; });
    el.addEventListener('pointercancel', function() { dragging = false; });
  }

  // ---------- topbar / chrome ----------

  function updateChrome() {
    var hasItems = items.length > 0;
    if (emptyEl) emptyEl.classList.toggle('gwb__canvas-empty--hidden', hasItems);
    if (addAllBtn) addAllBtn.disabled = !hasItems;
    if (mobileAddBtn) mobileAddBtn.disabled = !hasItems;
    if (mobileSubtotalEmpty) mobileSubtotalEmpty.hidden = hasItems;

    var sum = 0, sumCompare = 0, hasCompare = false;
    if (hasItems) {
      items.forEach(function(it) {
        sum += it.price;
        if (it.compareAtPrice && it.compareAtPrice > it.price) { sumCompare += it.compareAtPrice; hasCompare = true; }
        else { sumCompare += it.price; }
      });
    }

    if (subtotalWrap) {
      subtotalWrap.hidden = !hasItems;
      if (hasItems) {
        subtotalEl.textContent = formatMoney(sum);
        if (hasCompare) { subtotalCompare.textContent = formatMoney(sumCompare); subtotalCompare.hidden = false; }
        else { subtotalCompare.hidden = true; }
      }
    }
    if (mobileSubtotalWrap) {
      mobileSubtotalWrap.hidden = !hasItems;
      if (hasItems) {
        mobileSubtotal.textContent = formatMoney(sum);
        if (hasCompare) { mobileSubtotalCompare.textContent = formatMoney(sumCompare); mobileSubtotalCompare.hidden = false; }
        else { mobileSubtotalCompare.hidden = true; }
      }
    }
  }

  // Sizes drive the visual: cm × cmPerPx() gives the bounding box. After image
  // loads, the box is normalized to the mock's natural aspect to avoid clipping
  // for square (1:1 print) mocks placed in a non-1:1 box. No scale slider, no
  // pinch, `item.scale` stays at 1 always. cmPerPx() is canvas-relative so the
  // artwork stays in proportion with the room mockup at any viewport size.
  function applyBoxDimensions(item, el) {
    var parsed = parseSize(item.size, item.orientation);
    var ppc = cmPerPx();
    var w = parsed.w * ppc;
    var h = parsed.h * ppc;
    if (item._mockAspect && item._mockAspect > 0) {
      var area = w * h;
      h = Math.sqrt(area / item._mockAspect);
      w = h * item._mockAspect;
    }
    item._w = w; item._h = h;
    el.style.width = w + 'px';
    el.style.height = h + 'px';
  }

  // ---------- click canvas to deselect ----------
  function deselectAll() {
    selectedId = null;
    items.forEach(function(it) { if (it._el) it._el.classList.remove('is-selected'); });
    if (mobileFrameRow) mobileFrameRow.hidden = true;
  }
  canvas.addEventListener('pointerdown', function(e) {
    if (e.target === canvas || e.target === emptyEl) deselectAll();
  });

  // ---------- background mockup switching ----------
  function bindMockupRow() {
    var thumbs = mockupRow.querySelectorAll('.gwb__mockup-thumb');
    thumbs.forEach(function(t) {
      t.addEventListener('click', function() {
        var url = t.getAttribute('data-gwb-bg');
        canvas.style.backgroundImage = "url('" + url + "')";
        thumbs.forEach(function(x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }
  if (mockupRow) bindMockupRow();

  // ---------- canvas resize → re-scale all placed frames ----------
  // Because cmPerPx() is derived from canvas.clientWidth, every change in
  // canvas size (viewport resize, orientation change, sidebar collapse) needs
  // a re-render so artwork stays proportional to the room mockup.
  function reRenderAllItems() {
    if (!items.length) return;
    var rect = canvas.getBoundingClientRect();
    items.forEach(function(item) {
      if (!item._el) return;
      applyBoxDimensions(item, item._el);
      item.x = Math.max(0, Math.min(item.x, rect.width  - (item._w || 0) - 4));
      item.y = Math.max(0, Math.min(item.y, rect.height - (item._h || 0) - 4));
      item._el.style.left = item.x + 'px';
      item._el.style.top  = item.y + 'px';
    });
  }
  var _resizeRaf = null;
  function _onCanvasResize() {
    if (_resizeRaf) cancelAnimationFrame(_resizeRaf);
    _resizeRaf = requestAnimationFrame(reRenderAllItems);
  }
  if (window.ResizeObserver) {
    new ResizeObserver(_onCanvasResize).observe(canvas);
  } else {
    window.addEventListener('resize', _onCanvasResize);
    window.addEventListener('orientationchange', _onCanvasResize);
  }

  // ---------- file upload (HEIC-aware, silent-fail) ----------
  // iPhones default to HEIC, which most browsers can't natively decode. heic2any
  // is loaded from a LOCAL theme asset (data-heic2any-url) rather than a CDN,
  // Shopify's default CSP blocks third-party script CDNs. Loaded lazily only
  // when a HEIC file is uploaded.
  var heic2anyPromise = null;
  function loadHeic2any() {
    if (window.heic2any) return Promise.resolve(window.heic2any);
    if (heic2anyPromise) return heic2anyPromise;
    var url = builder.getAttribute('data-heic2any-url');
    if (!url) return Promise.reject(new Error('no asset'));
    heic2anyPromise = new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.onload = function() {
        if (window.heic2any) resolve(window.heic2any); else reject(new Error('library did not register'));
      };
      script.onerror = function() { reject(new Error('script load failed')); };
      document.head.appendChild(script);
    });
    return heic2anyPromise;
  }

  function setCanvasBackground(dataUrl) {
    canvas.style.backgroundImage = "url('" + dataUrl + "')";
    mockupRow.querySelectorAll('.gwb__mockup-thumb').forEach(function(t) { t.classList.remove('is-active'); });
  }

  if (uploadInput) {
    uploadInput.addEventListener('change', function() {
      var file = uploadInput.files[0];
      if (!file) return;
      var label = root.querySelector('.gwb__mockup-upload__label');
      var origLabel = label ? label.textContent : '';
      function restoreLabel() { if (label && origLabel) label.textContent = origLabel; }
      if (label) label.textContent = 'Loading…';

      // 1) Read the file as a data URL and try to render it as-is. Most JPG/PNG/
      //    WebP uploads succeed here. iOS Safari also natively renders HEIC.
      var reader = new FileReader();
      reader.onload = function(e) {
        var dataUrl = e.target.result;
        var test = new Image();
        test.onload = function() {
          setCanvasBackground(dataUrl);
          restoreLabel();
        };
        test.onerror = function() {
          // 2) Browser couldn't decode. If the file looks like HEIC, run it
          //    through heic2any. Otherwise give up silently, no alert, no
          //    friction. The user's mockup just doesn't change.
          var looksHeic = /\.(heic|heif)$/i.test(file.name) || /heic|heif/i.test(file.type || '');
          if (!looksHeic) { restoreLabel(); return; }
          loadHeic2any()
            .then(function(heic2any) {
              return heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 });
            })
            .then(function(jpegBlob) {
              return new Promise(function(resolve, reject) {
                var r2 = new FileReader();
                r2.onload = function(ev) { resolve(ev.target.result); };
                r2.onerror = reject;
                r2.readAsDataURL(jpegBlob);
              });
            })
            .then(function(jpegDataUrl) {
              setCanvasBackground(jpegDataUrl);
              restoreLabel();
            })
            .catch(function() {
              // Conversion failed, silently restore. No alert to the user.
              restoreLabel();
            });
        };
        test.src = dataUrl;
      };
      reader.onerror = restoreLabel;
      reader.readAsDataURL(file);
    });
  }

  // ---------- combined filter logic (search + category + space + orientation) ----------
  function activeFiltersFor(group) {
    // category + space are multi-select (OR within group); orientation is single-select
    return Array.prototype.slice.call(root.querySelectorAll('[data-gwb-filter-group="' + group + '"] .gwb__pill.is-active'))
      .map(function(b) { return b.getAttribute('data-filter-value') || ''; })
      .filter(function(v) { return v !== ''; });
  }

  var activeTab = 'prints'; // 'prints' | 'originals'

  function runFilters() {
    var q = (searchInput && searchInput.value.trim().toLowerCase()) || '';
    var categories = activeFiltersFor('category');
    var spaces = activeFiltersFor('space');
    var orientations = activeFiltersFor('orientation');
    var anyFilterActive = !!q || categories.length || spaces.length || orientations.length;
    var resetBtn = root.querySelector('[data-gwb-filter-reset]');
    if (resetBtn) resetBtn.hidden = !(categories.length || spaces.length || (orientations.length && orientations[0] !== ''));

    var cards = productsEl.querySelectorAll('.gwb__product-card');
    var visible = 0;
    cards.forEach(function(card) {
      var matchTab      = (card.dataset.productType || 'print') === (activeTab === 'originals' ? 'original' : 'print');
      var matchSearch   = !q || (card.dataset.title || '').indexOf(q) !== -1;
      var tagStr        = card.dataset.tags || '';
      var matchCategory = !categories.length || categories.some(function(t) { return tagStr.indexOf('|' + t + '|') !== -1; });
      var matchSpace    = !spaces.length || spaces.some(function(t) { return tagStr.indexOf('|' + t + '|') !== -1; });
      var matchOrient   = !orientations.length || orientations.indexOf(card.dataset.orientation) !== -1;
      var show = matchTab && matchSearch && matchCategory && matchSpace && matchOrient;
      card.classList.toggle('gwb__product-card--hidden', !show);
      if (show) visible++;
    });

    var noResults = productsEl.querySelector('.gwb__no-results');
    if (noResults) noResults.remove();
    if (visible === 0 && cards.length > 0) {
      var p = document.createElement('p');
      p.className = 'gwb__no-results';
      p.textContent = anyFilterActive
        ? 'No ' + (activeTab === 'originals' ? 'originals' : 'prints') + ' match these filters.'
        : 'No ' + (activeTab === 'originals' ? 'originals' : 'prints') + ' available.';
      productsEl.appendChild(p);
    }
  }

  if (searchInput) {
    // 'input' is the canonical event, but some virtual keyboards / autocomplete flows
    // emit only 'change' or composition events. Bind multiple as safety net.
    ['input', 'change', 'keyup', 'paste'].forEach(function(ev) {
      searchInput.addEventListener(ev, function() { runFilters(); });
    });
  }

  // category + space: multi-select toggle on click
  ['category', 'space'].forEach(function(group) {
    var groupEl = root.querySelector('[data-gwb-filter-group="' + group + '"]');
    if (!groupEl) return;
    groupEl.addEventListener('click', function(e) {
      var btn = e.target.closest('.gwb__pill');
      if (!btn) return;
      btn.classList.toggle('is-active');
      runFilters();
    });
  });

  // orientation: single-select (radio)
  var orientationGroup = root.querySelector('[data-gwb-filter-group="orientation"]');
  if (orientationGroup) {
    orientationGroup.addEventListener('click', function(e) {
      var btn = e.target.closest('.gwb__pill');
      if (!btn) return;
      orientationGroup.querySelectorAll('.gwb__pill').forEach(function(p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      runFilters();
    });
  }

  // reset all filters (except orientation default + search)
  var resetBtn = root.querySelector('[data-gwb-filter-reset]');
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      root.querySelectorAll('[data-gwb-filter-group="category"] .gwb__pill, [data-gwb-filter-group="space"] .gwb__pill').forEach(function(p) { p.classList.remove('is-active'); });
      var orient = root.querySelectorAll('[data-gwb-filter-group="orientation"] .gwb__pill');
      orient.forEach(function(p, i) { p.classList.toggle('is-active', i === 0); });
      runFilters();
    });
  }

  // ---------- tabs (Prints / Originals) ----------
  var tabs = root.querySelectorAll('.gwb__tab');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      activeTab = tab.getAttribute('data-gwb-tab') || 'prints';
      runFilters();
    });
  });

  // ---------- mobile size + frame selects ----------
  if (mobileSizeSelect) {
    mobileSizeSelect.addEventListener('change', function() {
      var it = currentItem();
      if (!it || !it._el) return;
      it.size = mobileSizeSelect.value;
      applyVariant(it, it._el);
      // mirror to in-frame popover select (desktop-resize sync)
      var inSizeSel = it._el.querySelectorAll('.gwb__variant-select')[1];
      if (inSizeSel) inSizeSel.value = it.size;
    });
  }
  if (mobileFrameSelect) {
    mobileFrameSelect.addEventListener('change', function() {
      var it = currentItem();
      if (!it || !it._el) return;
      it.frame = mobileFrameSelect.value;
      applyVariant(it, it._el);
      var inFrameSel = it._el.querySelectorAll('.gwb__variant-select')[0];
      if (inFrameSel) inFrameSel.value = it.frame;
    });
  }
  if (mobileDeleteBtn) {
    mobileDeleteBtn.addEventListener('click', function() {
      var it = currentItem();
      if (!it) return;
      if (it._el) it._el.remove();
      items = items.filter(function(x) { return x.id !== it.id; });
      deselectAll();
      updateChrome();
    });
  }

  // ---------- bottom sheet (mobile picker) ----------
  function openSheet() {
    if (!sidebarEl || !sheetOverlay) return;
    sidebarEl.classList.add('is-open');
    sheetOverlay.classList.add('is-open');
    sheetOverlay.hidden = false;
    document.body.classList.add('gwb-sheet-open');
  }
  function closeSheet() {
    if (!sidebarEl || !sheetOverlay) return;
    sidebarEl.classList.remove('is-open');
    sheetOverlay.classList.remove('is-open');
    document.body.classList.remove('gwb-sheet-open');
  }
  if (openPickerBtn) openPickerBtn.addEventListener('click', openSheet);
  if (sheetOverlay) sheetOverlay.addEventListener('click', closeSheet);
  if (sheetCloseBtn) sheetCloseBtn.addEventListener('click', closeSheet);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sidebarEl && sidebarEl.classList.contains('is-open')) closeSheet();
  });

  // After a product is added on mobile, auto-close the sheet (200ms delay so the user sees the placement land)
  var origAddFrame = addFrameForProduct;
  addFrameForProduct = function(product) {
    origAddFrame(product);
    if (isMobile()) setTimeout(closeSheet, 200);
  };
  // Rebind product cards after the override (loadProducts already finished, but if it races, cards still get the original closure via addProduct → addFrameForProduct lookup at click time would fail).
  // Card click handlers capture addFrameForProduct by closure at card-creation time. Since loadProducts hasn't run yet at this point in boot, the new closure is what they bind to.

  // ---------- add wall to cart ----------
  function addWallToCart(btn) {
    var cartItems = items.filter(function(it) { return it.variantId; }).map(function(it) {
      return { id: it.variantId, quantity: 1, properties: { '_From': 'Gallery Wall Builder' } };
    });
    if (!cartItems.length) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    }).then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = orig;
        if (typeof window.__openCartDrawer === 'function') {
          window.__openCartDrawer();
          btn.disabled = false;
        } else {
          window.location.href = '/cart';
        }
        if (typeof window.updateCartCount === 'function') window.updateCartCount();
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = orig;
      });
  }
  if (addAllBtn) addAllBtn.addEventListener('click', function() { addWallToCart(addAllBtn); });
  if (mobileAddBtn) mobileAddBtn.addEventListener('click', function() { addWallToCart(mobileAddBtn); });

  // ---------- boot ----------
  loadProducts();
  updateChrome();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  // Utility bar collapse + glass blur on scroll
  var wrap = document.getElementById('site-header-wrap');
  if (wrap) {
    var onScroll = function() {
      wrap.classList.toggle('header--scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile nav drawer (slide-in from left)
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.getElementById('mobile-nav');
  var navBackdrop = document.querySelector('.mobile-nav-backdrop');
  if (menuBtn && mobileNav) {
    var openNav = function() {
      menuBtn.setAttribute('aria-expanded', 'true');
      mobileNav.setAttribute('aria-hidden', 'false');
      if (navBackdrop) navBackdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    var closeNav = function() {
      menuBtn.setAttribute('aria-expanded', 'false');
      mobileNav.setAttribute('aria-hidden', 'true');
      if (navBackdrop) navBackdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    menuBtn.addEventListener('click', function() {
      mobileNav.getAttribute('aria-hidden') === 'false' ? closeNav() : openNav();
    });
    document.querySelectorAll('[data-menu-close]').forEach(function(el) {
      el.addEventListener('click', closeNav);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav.getAttribute('aria-hidden') === 'false') closeNav();
    });
  }

  // Mega menu (hover + click)
  var megaTrigger = document.querySelector('.site-header__mega-trigger');
  var megaMenu = document.getElementById('site-mega-menu');
  var megaNavItem = megaTrigger && megaTrigger.closest('.site-header__nav-item');
  if (megaTrigger && megaMenu && megaNavItem) {
    var closeTimeout;
    function openMega() {
      clearTimeout(closeTimeout);
      megaTrigger.setAttribute('aria-expanded', 'true');
      megaMenu.setAttribute('aria-hidden', 'false');
    }
    function closeMega() {
      closeTimeout = setTimeout(function() {
        megaTrigger.setAttribute('aria-expanded', 'false');
        megaMenu.setAttribute('aria-hidden', 'true');
      }, 80);
    }
    megaNavItem.addEventListener('mouseenter', openMega);
    megaNavItem.addEventListener('mouseleave', closeMega);
    megaMenu.addEventListener('mouseenter', function() { clearTimeout(closeTimeout); });
    megaMenu.addEventListener('mouseleave', closeMega);
    megaTrigger.addEventListener('click', function() {
      megaTrigger.getAttribute('aria-expanded') === 'true' ? closeMega() : openMega();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        clearTimeout(closeTimeout);
        megaTrigger.setAttribute('aria-expanded', 'false');
        megaMenu.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // Search overlay
  var searchOverlay = document.getElementById('search-overlay');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.getElementById('search-results');
  var searchDebounce;

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[data-open-search]').forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function() { if (searchInput) searchInput.focus(); }, 60);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-open-search]').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
  }

  document.querySelectorAll('[data-open-search]').forEach(function(btn) {
    btn.addEventListener('click', openSearch);
  });
  document.querySelectorAll('[data-close-search]').forEach(function(el) {
    el.addEventListener('click', closeSearch);
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.getAttribute('aria-hidden') === 'false') {
      closeSearch();
    }
  });

  // Predictive search is wired by assets/search-engine.js (initOverlay), which
  // reads [data-search-input] + #search-results + data-search-index. This file
  // only owns the open/close lifecycle above.
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.currentScript.closest('.shopify-section');
  if (!section) return;
  var track = section.querySelector('[data-carousel-track]');
  var prevBtn = section.querySelector('[data-carousel-prev]');
  var nextBtn = section.querySelector('[data-carousel-next]');
  if (!track) return;

  function scroll(dir) {
    var card = track.querySelector('.product-card');
    var gap = parseInt(getComputedStyle(track).gap) || 20;
    var amount = card ? card.offsetWidth + gap : 280;
    track.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { scroll(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { scroll(1); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function() {
  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function cartChange(itemKey, newQty, cartItemEl) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: newQty })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      var subtotalEl = document.querySelector('.cart-summary__price');
      var checkoutTotalEl = document.querySelector('.cart-summary__total');
      var totalStr = fmtMoney(cart.total_price);
      if (subtotalEl) subtotalEl.textContent = totalStr;
      if (checkoutTotalEl) checkoutTotalEl.textContent = totalStr;

      if (newQty === 0) {
        cartItemEl.remove();
        if (!document.querySelector('.cart-item')) window.location.reload();
        return;
      }

      var lineItem = cart.items.find(function(i) { return i.key === itemKey; });
      if (lineItem) {
        var priceEl = cartItemEl.querySelector('[data-line-price]');
        if (priceEl) priceEl.textContent = fmtMoney(lineItem.line_price);
      }
    })
    .catch(function() {});
  }

  document.querySelectorAll('[data-qty-change]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var idx = btn.getAttribute('data-qty-change');
      var delta = parseInt(btn.getAttribute('data-delta'), 10);
      var input = document.querySelector('[data-qty-input="' + idx + '"]');
      if (!input) return;
      var val = Math.max(0, parseInt(input.value, 10) + delta);
      input.value = val;
      var cartItemEl = btn.closest('.cart-item');
      var itemKey = cartItemEl ? cartItemEl.getAttribute('data-item-key') : null;
      if (itemKey) cartChange(itemKey, val, cartItemEl);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function() {
  var sortSel = document.querySelector('[data-sort-select]');
  if (sortSel) {
    sortSel.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }

  /* Grid density toggle (mobile) */
  var densityBtns = document.querySelectorAll('.collection-density__btn');
  densityBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var grid = document.getElementById('collection-grid');
      if (grid) grid.setAttribute('data-density', btn.dataset.density);
      densityBtns.forEach(function(b) { b.classList.toggle('is-active', b === btn); });
    });
  });

  var openBtn = document.getElementById('filters-open-btn');
  var closeBtn = document.getElementById('sidebar-close-btn');
  var sidebar = document.getElementById('collection-sidebar');
  var overlay = document.getElementById('sidebar-overlay');

  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }
  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }

  if (openBtn) openBtn.addEventListener('click', openSidebar);
  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
  if (overlay) overlay.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSidebar();
  });

  var grid = document.getElementById('collection-grid');
  var viewBtns = document.querySelectorAll('.collection-view-btn');
  viewBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var view = btn.getAttribute('data-view');
      if (grid) grid.setAttribute('data-view', view);
      viewBtns.forEach(function(b) { b.classList.toggle('is-active', b === btn); });
    });
  });

  var loadMoreContainer = document.getElementById('load-more-container');
  var loadMoreBtn = document.getElementById('load-more-btn');
  if (loadMoreBtn && loadMoreContainer && grid) {
    var loadMoreLabel = loadMoreBtn.textContent.trim();
    loadMoreBtn.addEventListener('click', function() {
      var nextUrl = loadMoreContainer.getAttribute('data-next-url');
      if (!nextUrl) return;
      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = '...';
      fetch(nextUrl)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('collection-grid');
          if (newGrid) {
            while (newGrid.firstChild) {
              grid.appendChild(newGrid.firstChild);
            }
          }
          var newContainer = doc.getElementById('load-more-container');
          if (newContainer && newContainer.getAttribute('data-next-url')) {
            loadMoreContainer.setAttribute('data-next-url', newContainer.getAttribute('data-next-url'));
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = loadMoreLabel;
          } else {
            loadMoreContainer.remove();
          }
        })
        .catch(function() {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = loadMoreLabel;
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-print-sets"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.main-print-sets');
  if (!section) return;

  var filterBar = section.querySelector('.filter-bar');
  var grid = document.getElementById('print-sets-grid');
  if (!filterBar || !grid) return;

  var filterBtns = filterBar.querySelectorAll('.filter-pill');
  var activeFilter = 'all';

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      activeFilter = btn.getAttribute('data-filter') || 'all';
      filterBtns.forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      applyFilter();
    });
  });

  function applyFilter() {
    var cards = grid.querySelectorAll('.print-set-card');
    cards.forEach(function(card) {
      if (activeFilter === 'all') {
        card.hidden = false;
        return;
      }
      var tags = (card.getAttribute('data-tags') || '').split(',').map(function(t) { return t.trim(); });
      card.hidden = !tags.some(function(t) { return t === activeFilter; });
    });
  }

  /* Re-apply filter after load-more appends new cards */
  var loadMoreBtn = document.getElementById('ps-load-more-btn');
  var loadMoreContainer = document.getElementById('ps-load-more-container');
  if (!loadMoreBtn || !loadMoreContainer) return;

  var label = loadMoreBtn.textContent.trim();
  loadMoreBtn.addEventListener('click', function() {
    var nextUrl = loadMoreContainer.getAttribute('data-next-url');
    if (!nextUrl) return;
    loadMoreBtn.disabled = true;
    loadMoreBtn.textContent = '…';
    fetch(nextUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('print-sets-grid');
        if (newGrid) {
          while (newGrid.firstChild) grid.appendChild(newGrid.firstChild);
        }
        var newContainer = doc.getElementById('ps-load-more-container');
        if (newContainer && newContainer.getAttribute('data-next-url')) {
          loadMoreContainer.setAttribute('data-next-url', newContainer.getAttribute('data-next-url'));
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = label;
        } else {
          loadMoreContainer.remove();
        }
        applyFilter();
      })
      .catch(function() {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = label;
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function() {

  /* ─── Gallery slides + dots ─────────────────────────────────── */
  var galleryMain = document.getElementById('product-gallery-main');
  var galleryDots = document.querySelectorAll('.product-gallery__dot');

  function activateGallerySlide(imageId) {
    var slides = document.querySelectorAll('.product-gallery__slide');
    var visibleIdx = -1, visibleCount = 0;
    slides.forEach(function(slide) {
      var hidden = slide.classList.contains('is-variant-hidden');
      var match  = String(slide.dataset.imageId) === String(imageId);
      slide.classList.toggle('is-active', match);
      if (!hidden) {
        if (match) visibleIdx = visibleCount;
        visibleCount++;
      }
    });
    document.querySelectorAll('.product-gallery__dot').forEach(function(d) {
      d.classList.toggle('is-active', String(d.dataset.imageId) === String(imageId));
    });
    if (visibleIdx >= 0 && galleryMain && window.matchMedia('(max-width: 767px)').matches) {
      galleryMain.scrollTo({ left: visibleIdx * galleryMain.clientWidth, behavior: 'smooth' });
    }
  }

  function filterGalleryByVariant(variantId) {
    var vid = String(variantId);
    document.querySelectorAll('.product-gallery__slide, .product-gallery__thumb, .product-gallery__dot').forEach(function(el) {
      var raw = el.dataset.variantIds;
      if (!raw) { el.classList.remove('is-variant-hidden'); return; }
      var match = raw.split(',').some(function(s) { return s === vid; });
      el.classList.toggle('is-variant-hidden', !match);
    });
    /* If the currently-active slide is now hidden, fall back to the first visible one. */
    var activeSlide = document.querySelector('.product-gallery__slide.is-active');
    if (activeSlide && activeSlide.classList.contains('is-variant-hidden')) {
      var firstVisible = document.querySelector('.product-gallery__slide:not(.is-variant-hidden)');
      if (firstVisible) activateGallerySlide(firstVisible.dataset.imageId);
    }
  }

  /* ─── Gallery thumbnails ────────────────────────────────────── */
  document.querySelectorAll('.product-gallery__thumb').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.product-gallery__thumb').forEach(function(t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
      activateGallerySlide(btn.dataset.imageId);
    });
  });

  /* ─── Accordion ─────────────────────────────────────────────── */
  document.querySelectorAll('.product-detail-item__trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item    = btn.closest('.product-detail-item');
      var body    = item.querySelector('.product-detail-item__body');
      var isOpen  = item.classList.toggle('product-detail-item--open');
      body.style.maxHeight = isOpen ? body.scrollHeight + 'px' : '0';
      btn.setAttribute('aria-expanded', isOpen);
    });
    /* Set initial open state */
    if (btn.closest('.product-detail-item').classList.contains('product-detail-item--open')) {
      var body = btn.closest('.product-detail-item').querySelector('.product-detail-item__body');
      if (body) body.style.maxHeight = body.scrollHeight + 'px';
    }
  });

  /* ─── Quantity stepper ──────────────────────────────────────── */
  var qtyInput = document.querySelector('[data-qty-input]');
  if (qtyInput) {
    document.querySelector('[data-qty-dec]') && document.querySelector('[data-qty-dec]').addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > parseInt(qtyInput.min || '1', 10)) { qtyInput.value = v - 1; }
    });
    document.querySelector('[data-qty-inc]') && document.querySelector('[data-qty-inc]').addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      var max = parseInt(qtyInput.max || '99', 10);
      if (v < max) { qtyInput.value = v + 1; }
    });
  }

  /* ─── Countdown timer ───────────────────────────────────────── */
  var countdownEl = document.querySelector('[data-countdown-timer]');
  if (countdownEl) {
    var wrapper     = countdownEl.closest('[data-end-date]');
    var endDate     = new Date(wrapper && wrapper.dataset.endDate).getTime();
    var afterText   = wrapper && wrapper.dataset.afterText || 'Drop closed';
    var showSeconds = wrapper && wrapper.dataset.showSeconds !== 'false';
    function updateCountdown() {
      var diff = endDate - Date.now();
      if (isNaN(diff) || diff <= 0) { countdownEl.textContent = afterText; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var parts = [];
      if (d > 0) parts.push(d + 'd');
      parts.push(('0' + h).slice(-2) + 'h');
      parts.push(('0' + m).slice(-2) + 'm');
      if (showSeconds) parts.push(('0' + s).slice(-2) + 's');
      countdownEl.textContent = parts.join(' ');
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ─── Variant selection + price/urgency/sticky ATC ─────────── */
  var variantsEl = document.getElementById('product-variants-json');
  if (variantsEl) {
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch(e) {}

    var variantIdInput  = document.querySelector('.shopify-product-form [name="id"]');
    var atcBtn          = document.querySelector('[data-atc-btn]');
    var priceEl         = document.querySelector('[data-price]');
    var urgencyEl       = document.getElementById('stock-urgency-msg');
    var urgencyTextEl   = document.getElementById('stock-urgency-text');
    var stickyPriceEl   = document.querySelector('[data-sticky-price]');
    var stickyCompareEl = document.querySelector('[data-sticky-compare]');
    var stickyAtcBtn    = document.querySelector('[data-sticky-atc-btn]');
    var threshold       = urgencyEl ? parseInt(urgencyEl.dataset.threshold || '5', 10) : 5;

    function getSelectedOptions() {
      var byIndex = {};
      /* New block types (frame_swatches, size_picker) use data-variant-option */
      document.querySelectorAll('[data-variant-option]').forEach(function(radio) {
        if (radio.checked) {
          var idx = parseInt(radio.dataset.optionIndex, 10);
          if (!isNaN(idx)) byIndex[idx] = radio.value;
        }
      });
      /* Legacy variant_options block */
      document.querySelectorAll('.variant-selector').forEach(function(sel) {
        var idx = parseInt(sel.dataset.optionIndex, 10);
        if (!isNaN(idx) && byIndex[idx] === undefined) {
          var checked = sel.querySelector('input[type="radio"]:checked');
          if (checked) byIndex[idx] = checked.value;
        }
      });
      var opts = [];
      Object.keys(byIndex).map(Number).sort(function(a, b) { return a - b; }).forEach(function(k) { opts.push(byIndex[k]); });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function(v) {
        return opts.every(function(val, i) { return v.options[i] === val; });
      });
    }
    function applyVariant(v) {
      if (!v) return;
      if (variantIdInput) { variantIdInput.value = v.id; variantIdInput.dispatchEvent(new Event('change', { bubbles: true })); }
      var paymentTermsEl = document.querySelector('shopify-payment-terms');
      if (paymentTermsEl) paymentTermsEl.setAttribute('variant-id', v.id);
      /* URL sync */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch(e) {}
      /* ATC button */
      var addText  = atcBtn ? (atcBtn.dataset.addText  || 'Add to Cart') : 'Add to Cart';
      var soldText = atcBtn ? (atcBtn.dataset.soldText || 'Sold out')     : 'Sold out';
      var showPrice = atcBtn && atcBtn.dataset.showPrice !== 'false';
      if (atcBtn) {
        if (v.available) {
          atcBtn.disabled = false;
          atcBtn.innerHTML = addText + (showPrice ? ' &middot; <span class="atc-price">' + v.price_formatted + '</span>' : '');
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = soldText;
        }
      }
      /* Prices */
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (stickyPriceEl) stickyPriceEl.textContent = v.price_formatted;
      if (stickyCompareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price && v.compare_at_price_formatted) {
          stickyCompareEl.textContent = v.compare_at_price_formatted;
          stickyCompareEl.hidden = false;
        } else {
          stickyCompareEl.hidden = true;
        }
      }
      var compareEl = document.querySelector('[data-compare-price]');
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price && v.compare_at_price_formatted) {
          compareEl.textContent = v.compare_at_price_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      /* Sticky ATC */
      if (stickyAtcBtn) {
        stickyAtcBtn.disabled = !v.available;
        var stickyLabel = stickyAtcBtn.querySelector('.sticky-atc__label');
        if (stickyLabel) {
          stickyLabel.textContent = v.available ? addText : soldText;
        } else {
          stickyAtcBtn.textContent = v.available ? addText : soldText;
        }
        var stickyPriceEl = document.querySelector('[data-sticky-price]');
        if (stickyPriceEl) stickyPriceEl.textContent = v.price_formatted;
      }
      /* Stock urgency */
      if (urgencyEl && urgencyTextEl) {
        var tracked = v.inventory_management === 'shopify' && v.inventory_policy === 'deny';
        if (v.available && tracked && v.inventory_quantity > 0 && v.inventory_quantity <= threshold) {
          var prefix = urgencyEl.dataset.prefix || 'Only';
          var suffix = urgencyEl.dataset.suffix || 'left';
          urgencyTextEl.textContent = prefix + ' ' + v.inventory_quantity + ' ' + suffix;
          urgencyEl.hidden = false;
        } else {
          urgencyEl.hidden = true;
        }
      }
      /* Gallery image sync */
      filterGalleryByVariant(v.id);
      if (v.featured_image && v.featured_image.id) {
        activateGallerySlide(v.featured_image.id);
        document.querySelectorAll('.product-gallery__thumb').forEach(function(th) {
          th.classList.toggle('is-active', parseInt(th.dataset.imageId, 10) === v.featured_image.id);
        });
      }
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: v } }));
    }

    /* Size dimension label */
    var dimsDisplay = document.querySelector('[data-size-dims]');
    document.querySelectorAll('.variant-selector__options--sizes input[type="radio"]').forEach(function(radio) {
      if (radio.checked && dimsDisplay) dimsDisplay.textContent = radio.dataset.dims ? ': ' + radio.dataset.dims : '';
      radio.addEventListener('change', function() {
        if (dimsDisplay) dimsDisplay.textContent = radio.dataset.dims ? ': ' + radio.dataset.dims : '';
      });
    });

    document.querySelectorAll('.variant-selector input[type="radio"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        var v = findVariant(getSelectedOptions());
        if (v) applyVariant(v);
        /* Legacy swatch selected state */
        var parent = radio.closest('.variant-swatches');
        if (parent) {
          parent.querySelectorAll('.variant-swatch').forEach(function(sw) { sw.classList.remove('is-selected'); });
          radio.closest('.variant-swatch') && radio.closest('.variant-swatch').classList.add('is-selected');
        }
      });
    });

    /* New block types: frame_swatches + size_picker */
    document.querySelectorAll('[data-variant-option]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        var optIdx = radio.dataset.optionIndex;
        /* Update active classes for sibling options */
        document.querySelectorAll('[data-variant-option][data-option-index="' + optIdx + '"]').forEach(function(r) {
          var sw = r.closest('.pbi-swatch');
          var sz = r.closest('.pbi-size-btn');
          if (sw) sw.classList.toggle('pbi-swatch--active', r === radio);
          if (sz) sz.classList.toggle('pbi-size-btn--active', r === radio);
        });
        /* Update frame selected label */
        if (radio.closest('.pbi-frame-swatches')) {
          var fl = document.querySelector('[data-frame-selected-label]');
          if (fl) fl.textContent = radio.value;
        }
        /* Update size selected label + dims */
        if (radio.closest('.pbi-size-picker')) {
          var sl = document.querySelector('[data-size-selected-label]');
          if (sl) {
            var lbl = radio.dataset.sizeLabel || radio.value;
            var dims = radio.dataset.sizeDims || '';
            sl.innerHTML = lbl + (dims ? '<span class="pbi-opt-dims"> · ' + dims + '</span>' : '');
          }
        }
        var v = findVariant(getSelectedOptions());
        if (v) applyVariant(v);
      });
    });

    /* ─── Size anchoring: auto-select largest available variant ── */
    (function() {
      var available = variants.filter(function(v) { return v.available; });
      if (available.length < 2) return;
      var largest = available.reduce(function(a, b) { return b.price > a.price ? b : a; });
      var current = findVariant(getSelectedOptions());
      if (current && current.id === largest.id) return;
      largest.options.forEach(function(val, idx) {
        document.querySelectorAll('[data-variant-option][data-option-index="' + idx + '"]').forEach(function(r) {
          r.checked = (r.value === val);
          var sw = r.closest('.pbi-swatch');
          var sz = r.closest('.pbi-size-btn');
          if (sw) sw.classList.toggle('pbi-swatch--active', r.value === val);
          if (sz) sz.classList.toggle('pbi-size-btn--active', r.value === val);
        });
        document.querySelectorAll('.variant-selector[data-option-index="' + idx + '"] input[type="radio"]').forEach(function(r) {
          r.checked = (r.value === val);
        });
      });
      var fl = document.querySelector('[data-frame-selected-label]');
      if (fl) {
        var frameOptIdx = null;
        document.querySelectorAll('[data-variant-option]').forEach(function(r) {
          if (r.closest('.pbi-frame-swatches') && frameOptIdx === null) frameOptIdx = parseInt(r.dataset.optionIndex, 10);
        });
        if (frameOptIdx !== null && largest.options[frameOptIdx]) fl.textContent = largest.options[frameOptIdx];
      }
      var sl = document.querySelector('[data-size-selected-label]');
      if (sl) {
        var sizeOptIdx = null;
        document.querySelectorAll('[data-variant-option]').forEach(function(r) {
          if (r.closest('.pbi-size-picker') && sizeOptIdx === null) sizeOptIdx = parseInt(r.dataset.optionIndex, 10);
        });
        if (sizeOptIdx !== null) {
          var sizeVal = largest.options[sizeOptIdx];
          var matchR = null;
          document.querySelectorAll('.pbi-size-picker [data-variant-option]').forEach(function(r) {
            if (r.value === sizeVal) matchR = r;
          });
          if (matchR) {
            var lbl = matchR.dataset.sizeLabel || sizeVal;
            var dims = matchR.dataset.sizeDims || '';
            sl.innerHTML = lbl + (dims ? '<span class="pbi-opt-dims"> · ' + dims + '</span>' : '');
          }
        }
      }
      applyVariant(largest);
    })();
  }

  /* ─── Sticky ATC visibility ─────────────────────────────────── */
  var stickyBar = document.getElementById('sticky-atc');
  var mainAtc   = document.querySelector('[data-atc-btn]');
  if (stickyBar && mainAtc) {
    stickyBar.removeAttribute('aria-hidden');
    var observer = new IntersectionObserver(function(entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(mainAtc);
    var stickyTrigger = stickyBar.querySelector('[data-sticky-atc-btn]');
    if (stickyTrigger) {
      stickyTrigger.addEventListener('click', function() {
        var form = mainAtc.closest('form');
        if (form) form.requestSubmit();
      });
    }
  }

  /* ─── Originals notify form (Klaviyo client subscriptions) ──── */
  var notifyForm = document.querySelector('[data-originals-notify-form]');
  if (notifyForm) {
    var notifyBtn   = notifyForm.querySelector('[data-notify-submit]');
    var notifyEmail = notifyForm.querySelector('[data-notify-email]');
    var submitNotify = function() {
      var company = notifyForm.dataset.company;
      var listId  = notifyForm.dataset.list;
      var email = notifyEmail ? notifyEmail.value.trim() : '';
      var errEl = notifyForm.querySelector('[data-notify-error]');
      var okEl  = document.querySelector('[data-notify-success]');
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errEl) { errEl.textContent = 'Please enter a valid email.'; errEl.hidden = false; }
        return;
      }
      if (errEl) errEl.hidden = true;
      if (notifyBtn) notifyBtn.disabled = true;
      var body = { data: { type: 'subscription', attributes: {
        custom_source: 'Originals private collection',
        profile: { data: { type: 'profile', attributes: {
          email: email,
          properties: {
            interested_original_title:  notifyForm.dataset.title || '',
            interested_original_handle: notifyForm.dataset.handle || ''
          }
        } } }
      } } };
      if (listId) body.data.relationships = { list: { data: { type: 'list', id: listId } } };
      var done = function() {
        notifyForm.style.display = 'none';
        if (okEl) okEl.hidden = false;
        if (notifyBtn) notifyBtn.disabled = false;
      };
      if (!company) { done(); return; }
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
        body: JSON.stringify(body)
      }).then(done, done);
    };
    if (notifyBtn) notifyBtn.addEventListener('click', submitNotify);
    if (notifyEmail) notifyEmail.addEventListener('keydown', function(ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); submitNotify(); }
    });
  }

  /* ─── Gallery swipe dots (scroll sync) ─────────────────────── */
  if (galleryMain && galleryDots.length > 0) {
    galleryMain.addEventListener('scroll', function() {
      var idx = Math.round(galleryMain.scrollLeft / Math.max(galleryMain.clientWidth, 1));
      galleryDots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
    }, { passive: true });
  }

  /* ─── Viewer count ─────────────────────────────────────────── */
  var viewerEl = document.querySelector('.pbi-viewer-count');
  if (viewerEl) {
    var vMin = parseInt(viewerEl.dataset.min, 10) || 3;
    var vMax = parseInt(viewerEl.dataset.max, 10) || 12;
    var vSuffix = viewerEl.dataset.suffix || 'people viewing this right now';
    var vCountEl = viewerEl.querySelector('[data-viewer-count-text]');
    function updateViewerCount() {
      var count = Math.floor(Math.random() * (vMax - vMin + 1)) + vMin;
      if (vCountEl) vCountEl.textContent = count + ' ' + vSuffix;
      viewerEl.removeAttribute('hidden');
    }
    updateViewerCount();
    setInterval(updateViewerCount, Math.floor((150 + Math.random() * 60) * 1000));
  }

})();

(function () {
  if (window.__sgModalInited) return;
  window.__sgModalInited = true;

  var modal    = document.getElementById('size-guide-modal');
  var roomEl   = document.getElementById('sgRoom');
  var frameEl  = document.getElementById('sgFrame');
  var artImg   = document.getElementById('sgArtworkImg');
  var btnWrap  = document.getElementById('sgSizeBtns');
  var trigger  = document.querySelector('.sg-modal-trigger');
  var closeBtn = modal && modal.querySelector('.sg-modal-close');

  if (!modal || !roomEl || !frameEl || !artImg || !btnWrap || !trigger || !closeBtn) return;

  var productImage = roomEl.dataset.productImage || '';
  var _bgCache = {};

  /* Flood-fill from image edges: any near-black pixel connected to the border
     becomes transparent, removing the solid black outer background while
     preserving the white mat and frame. Falls back to original src on CORS error. */
  function removeBlackBg(src, done) {
    if (_bgCache[src]) { done(_bgCache[src]); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var W = img.naturalWidth, H = img.naturalHeight;
        var cv = document.createElement('canvas');
        cv.width = W; cv.height = H;
        var ctx = cv.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var id = ctx.getImageData(0, 0, W, H);
        var px = id.data;
        var DARK = 35;
        var visited = new Uint8Array(W * H);
        var q = [], qi = 0;
        function seed(x, y) {
          var i = y * W + x;
          if (!visited[i] && px[i*4] < DARK && px[i*4+1] < DARK && px[i*4+2] < DARK) {
            visited[i] = 1; q.push(i);
          }
        }
        for (var x = 0; x < W; x++) { seed(x, 0); seed(x, H-1); }
        for (var y = 1; y < H-1; y++) { seed(0, y); seed(W-1, y); }
        while (qi < q.length) {
          var cur = q[qi++];
          var p = cur * 4;
          px[p] = 0; px[p+1] = 0; px[p+2] = 0; px[p+3] = 0;
          var cx = cur % W, cy = (cur / W) | 0;
          var ns = [cx > 0 ? cur-1 : -1, cx < W-1 ? cur+1 : -1,
                    cy > 0 ? cur-W : -1, cy < H-1 ? cur+W : -1];
          for (var n = 0; n < 4; n++) {
            var ni = ns[n];
            if (ni < 0 || visited[ni]) continue;
            if (px[ni*4] < DARK && px[ni*4+1] < DARK && px[ni*4+2] < DARK) {
              visited[ni] = 1; q.push(ni);
            }
          }
        }
        ctx.putImageData(id, 0, 0);
        var result = cv.toDataURL('image/png');
        _bgCache[src] = result;
        done(result);
      } catch (e) { done(src); }
    };
    img.onerror = function () { done(src); };
    img.src = src;
  }

  function setArtwork(src) {
    removeBlackBg(src, function (processed) { artImg.src = processed; });
  }

  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.variant && e.detail.variant.featured_image) {
      productImage = e.detail.variant.featured_image.src;
      if (artImg.src) setArtwork(productImage);
    }
  });

  function getSizes() {
    var seen = {};
    return [].slice.call(document.querySelectorAll('[data-size-dims]')).map(function (btn) {
      var parentLabel = btn.closest('label');
      var rawVal = (parentLabel && parentLabel.dataset.value) || btn.value || '';
      var dims  = btn.dataset.sizeDims || rawVal;
      var label = btn.dataset.sizeLabel || (parentLabel && parentLabel.dataset.label) || rawVal;
      var match = dims.match(/(\d+)[x×](\d+)/i);
      if (!match) return null;
      var key = match[1] + 'x' + match[2];
      if (seen[key]) return null;
      seen[key] = true;
      var isActive = parentLabel
        ? parentLabel.classList.contains('pbi-size-btn--active')
        : (btn.getAttribute('aria-pressed') === 'true');
      return { w: parseInt(match[1], 10), h: parseInt(match[2], 10), label: label, active: isActive, dims: dims };
    }).filter(Boolean);
  }

  function showSize(s) {
    var roomW = roomEl.offsetWidth;
    var roomH = roomEl.offsetHeight;
    /* Room image is 1280×720. Door height ≈ 92.4% of image height = 200 cm. */
    var ppc = (roomH * 0.924) / 200;
    var fw = s.w * ppc;
    var fh = s.h * ppc;
    /* Horizontal centre of safe wall zone (between plant ~30% and door ~68%). */
    var cx = roomW * 0.49;
    /* Vertical centre of wall (top 8% → baseboard 82%). */
    var cy = roomH * 0.42;
    frameEl.style.left   = (cx - fw / 2).toFixed(1) + 'px';
    frameEl.style.top    = (cy - fh / 2).toFixed(1) + 'px';
    frameEl.style.width  = fw.toFixed(1) + 'px';
    frameEl.style.height = fh.toFixed(1) + 'px';
    setArtwork(productImage);
    btnWrap.querySelectorAll('.sg-size-btn').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.dims === s.dims);
    });
  }

  function buildButtons(sizes) {
    btnWrap.innerHTML = '';
    sizes.forEach(function (s) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sg-size-btn' + (s.active ? ' is-active' : '');
      btn.dataset.dims = s.dims;
      btn.textContent = s.label;
      btn.addEventListener('click', function () { showSize(s); });
      btnWrap.appendChild(btn);
    });
  }

  function openModal() {
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var sizes = getSizes();
    buildButtons(sizes);
    var active = sizes.find(function (x) { return x.active; }) || sizes[sizes.length - 1];
    if (active) showSize(active);
    closeBtn.focus();
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    trigger.focus();
  }

  document.querySelectorAll('.sg-modal-trigger').forEach(function (t) {
    t.addEventListener('click', openModal);
  });
  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();

/* ─── Tap-to-zoom lightbox ──────────────────────────────────── */
(function () {
  var zoom = document.querySelector('[data-pdp-zoom]');
  if (!zoom) return;
  var img   = zoom.querySelector('[data-zoom-img]');
  var stage = zoom.querySelector('[data-zoom-stage]');
  var closeBtn = zoom.querySelector('[data-zoom-close]');
  var galleryMain = document.getElementById('product-gallery-main');

  function resetZoom() { zoom.classList.remove('is-zoomed'); img.style.width = ''; }

  function open(src) {
    resetZoom();
    img.src = src;
    zoom.hidden = false;
    zoom.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { zoom.classList.add('is-open'); });
  }
  function close() {
    zoom.classList.remove('is-open');
    resetZoom();
    document.documentElement.style.overflow = '';
    setTimeout(function () { zoom.hidden = true; zoom.setAttribute('aria-hidden', 'true'); }, 300);
  }

  if (galleryMain) {
    galleryMain.addEventListener('click', function (e) {
      var slide = e.target.closest ? e.target.closest('.product-gallery__slide') : null;
      if (!slide) return;
      var base = slide.getAttribute('src') || '';
      var hi = base.replace(/([?&]width=)\d+/, '$1' + 2048);
      open(hi);
    });
  }

  img.addEventListener('click', function (e) {
    e.stopPropagation();
    if (zoom.classList.contains('is-zoomed')) { resetZoom(); return; }
    var rect = img.getBoundingClientRect();
    var relX = (e.clientX - rect.left) / rect.width;
    var relY = (e.clientY - rect.top) / rect.height;
    zoom.classList.add('is-zoomed');
    var natural = img.naturalWidth || Math.round(window.innerWidth * 2);
    img.style.width = Math.min(natural, Math.round(window.innerWidth * 2.2)) + 'px';
    requestAnimationFrame(function () {
      stage.scrollLeft = relX * img.offsetWidth - stage.clientWidth / 2;
      stage.scrollTop  = relY * img.offsetHeight - stage.clientHeight / 2;
    });
  });

  closeBtn.addEventListener('click', close);
  zoom.addEventListener('click', function (e) { if (e.target === zoom || e.target === stage) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !zoom.hidden) close();
  });
})();

/* ─── About our frames modal ────────────────────────────────── */
(function () {
  var modal = document.querySelector('[data-frames-modal]');
  if (!modal) return;
  var openers = document.querySelectorAll('[data-frames-open]');
  var closeBtn = modal.querySelector('[data-frames-close]');

  function open() {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
  }
  function close() {
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 300);
  }
  openers.forEach(function (o) { o.addEventListener('click', open); });
  closeBtn.addEventListener('click', close);
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function shuffleAndTrim(el) {
    var items = Array.prototype.slice.call(el.children);
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
    }
    var limit = parseInt(el.getAttribute('data-rp-limit'), 10) || items.length;
    items.forEach(function (node, idx) {
      if (idx >= limit) { node.remove(); }
      else { el.appendChild(node); }
    });
  }
  document.querySelectorAll('[data-rp-shuffle]').forEach(shuffleAndTrim);

  var carousels = document.querySelectorAll('[data-rp-carousel]');
  carousels.forEach(function (carousel) {
    var track = carousel.querySelector('[data-rp-track]');
    var prev = carousel.querySelector('[data-rp-prev]');
    var next = carousel.querySelector('[data-rp-next]');
    if (!track) return;

    function pageWidth() {
      var item = track.querySelector('.related-products__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var cardW = item.getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.round(track.clientWidth / cardW));
      return perView * cardW;
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.hidden = track.scrollLeft <= 1;
      if (next) next.hidden = track.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -pageWidth(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: pageWidth(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
(function() {
  var grid = document.getElementById('wishlist-grid');
  if (!grid) return;

  var handles;
  try { handles = JSON.parse(localStorage.getItem('wishlist') || '[]'); } catch(e) { handles = []; }

  if (!handles.length) {
    grid.innerHTML = '<div class="wishlist-page__empty"><p>Your wishlist is empty.</p><a href="/collections/all" class="btn">View all works →</a></div>';
    return;
  }

  grid.innerHTML = '';
  var loaded = 0;
  handles.forEach(function(handle) {
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var price = p.price_varies
          ? 'From ' + (p.price_min / 100).toLocaleString('en-US', { style: 'currency', currency: p.currency || 'USD' })
          : (p.price / 100).toLocaleString('en-US', { style: 'currency', currency: p.currency || 'USD' });
        var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="' + p.title.replace(/"/g, '') + '" loading="lazy" width="400">' : '';
        var card = document.createElement('a');
        card.href = '/products/' + p.handle;
        card.className = 'product-card';
        card.setAttribute('aria-label', p.title);
        card.innerHTML = '<div class="product-card__image">' + img + '</div><p class="product-card__title">' + p.title + '</p><p class="product-card__price">' + price + '</p>';
        grid.appendChild(card);
      })
      .catch(function() {})
      .finally(function() {
        loaded++;
        if (loaded === handles.length && !grid.children.length) {
          grid.innerHTML = '<div class="wishlist-page__empty"><p>Your wishlist is empty.</p><a href="/collections/all" class="btn">View all works →</a></div>';
        }
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
